import gql from 'graphql-tag';

const CUSTOMER_FEEDACK_LOG_VIEW = gql`
  mutation customerFeedbackLogView($student_book_id: ID!) {
    customer_feedback_log_view(student_book_id: $student_book_id) {
      result
    }
  }
`;

const CUSTOMER_FEEDACK_LOG_VIEW_MSB = gql`
  mutation customerFeedbackLogView($student_book_id: ID!) {
    logCustomerFeedbackView(student_book_id: $student_book_id) {
      result
    }
  }
`;

const CUSTOMER_FEEDACK_ANSWER = gql`
  mutation customerFeedbackSaveAnswer(
    $student_book_id: ID!
    $feedback: [FeedbackInput!]!
    $reason: String
  ) {
    customer_feedback_save_mystage(student_book_id: $student_book_id, feedback: $feedback, reason: $reason) {
      result
    }
  }
`;

const CUSTOMER_FEEDACK_ANSWER_MSB = gql`
  mutation customerFeedbackSaveAnswer(
    $student_book_id: ID!
    $feedback: [FeedbackInput!]!
    $reason: String
  ) {
    saveCustomerFeedback(student_book_id: $student_book_id, feedback: $feedback, reason: $reason) {
      result
    }
  }
`;


const DISLIKE_SETTING = gql`
  mutation DislikeSetting($teacher_id: ID!, $setting: Boolean!) {
    dislike_setting(teacher_id: $teacher_id, setting: $setting) {
      result {
        result
        message
      }
    }
  }
`;

const DISLIKE_SETTING_MSB = gql`
  mutation DislikeSetting($teacher_id: ID!, $setting: Boolean!) {
    updateDislikeSetting(teacher_id: $teacher_id, setting: $setting) {
      result
    }
  }
`;

export { 
  CUSTOMER_FEEDACK_LOG_VIEW,
  CUSTOMER_FEEDACK_LOG_VIEW_MSB, 
  CUSTOMER_FEEDACK_ANSWER, 
  CUSTOMER_FEEDACK_ANSWER_MSB,
  DISLIKE_SETTING,
  DISLIKE_SETTING_MSB
};
